import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import HeadSub from "../../../components/comm/HeadSub";
import Navbar from "../../../components/comm/Navbar";
import ChatBotServiceInformBox from "../../../components/box/ChatBotServiceInformBox";
import style from './Chat.module.css';
import URL from "../../../constants/url";
import CircularProgress from '@mui/material/CircularProgress';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';


import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import {  getLoadingHandler } from '../../../assets/js/comm';

const tempRecom = [
    {ctgrySeCd : "HMC", nttSj : "추천 키워드1", nttCn: "추천 검색 키워드는 추후 정의 예정"},
    {ctgrySeCd : "HMC", nttSj : "추천 키워드2", nttCn: "추천 검색 키워드는 추후 정의 예정"},
    {ctgrySeCd : "HMC", nttSj : "추천 키워드3", nttCn: "추천 검색 키워드는 추후 정의 예정"},
    {ctgrySeCd : "HMC", nttSj : "추천 키워드4", nttCn: "추천 검색 키워드는 추후 정의 예정"},
    {ctgrySeCd : "HMC", nttSj : "추천 키워드5", nttCn: "추천 검색 키워드는 추후 정의 예정"},
    {ctgrySeCd : "HMC", nttSj : "홈케어", nttCn: "추천 검색 키워드는 추후 정의 예정"},
];


const ServiceChat = () => {

    const chatbotInfoParam = {chtbSeCd : "A", ctgrySeCd : "HMC"};

    //챗봇 정보
    const [chatbotInfo, setChatbotInfo] = useState();

    //카테고리 목록
    const [cdList, setCdList] = useState([]);

    //전체보기 텍스트
    const [allText, setAllText] = useState('');

    //스크롤
    const chatEndRef = useRef(null);

    //입력 텍스트
    const [textQuestion, setTextQuestion] = useState("");

    //채팅
    const [chatList, setChatList] = useState([]);   

    //전송중 체크
    const isSendingRef = useRef(false);

    useEffect(() => {
        // console.log(chatList);
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [chatList]);

    //최초 카테고리 가져오기
    useEffect(() => {
        getChatbotInitInfo();
    },[]);

    useEffect(() => {
        if(chatbotInfo) {
            setInitChat();
        }
    },[chatbotInfo])


    const setInitChat = useCallback(() => {

        const nowDate = getCurrentDateStr();

        setChatList(prev => {
            const lastDateInChat = [...prev].reverse().find(item => item.type === 'date')?.dateStr;
            const newChatList = [...prev];

            // 날짜 변경되었으면 날짜 라인 추가
            if (nowDate !== lastDateInChat) {
                newChatList.push({ type: 'date', dateStr: nowDate, date: getCurrentDate() });
            }

            newChatList.push({
                type: 'bot',
                // text: '안녕하세요. 케어플러스 챗봇입니다.\n안내가 필요하신 메뉴 버튼을 선택하거나\n안내가 필요한 키워드를 입력해주세요.',
                text: chatbotInfo?.chtbDc,
                source: 'init',
                date: getCurrentDate(),
                chatTime : getCurrentTime(),
            });
            return newChatList;
        });
    }, [chatbotInfo])


    const getRuleBaseData = useCallback(async (ctgry) => {

        if (isSendingRef.current) return;

        isSendingRef.current = true;

        addUserChat(ctgry.chtbCmtCn);
        
        const url = "/chatbot/rule/retrieveRuleBaseAnswerList";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
            noLoading: true,
        }

        await axiosApi.post(url, {...chatbotInfoParam, ctgrySeCd: ctgry.ctgrySeCd , bbsMasId : 1}, reqOptions)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const resultList = res.data.result.resultList;
                addBotChatFollows(ctgry.chtbCmtCn + " 메뉴 관련 자주 묻는 질문입니다. 궁금하신 질문 제목을 선택해주세요.", resultList)
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("챗봇 목록록 호출중 오류 : ", err);
            setChatList((prev) => {
                const updated = prev.filter(chat => chat.source !== 'waiting');
                const newItems = [
                    { 
                        type: 'bot',
                        text: "오류가 발생했어요. 다시 시도해주세요.", 
                        source: 'api', 
                        date: getCurrentDate(), 
                        chatTime: getCurrentTime() 
                    },
                ];
                return [...updated, ...newItems]
            });
        }).finally(() => {
            isSendingRef.current = false;
        });
        
    }, []);

    const getRuleBaseDataForQuestion = useCallback(async (question) => {
        if (!question.trim() || isSendingRef.current) return;

        isSendingRef.current = true;

        addUserChat(question);
        
        const url = "/chatbot/rule/retrieveRuleBaseAnswerList";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
            noLoading: true,
        }

        await axiosApi.post(url, {chtbSeCd : "A", bbsMasId : 1, question : question}, reqOptions)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const resultList = res.data.result.resultList;
                if(resultList.length > 0) {
                    addBotChatFollows(question + " 관련 자주 묻는 질문입니다. 궁금하신 질문 제목을 선택해주세요.", resultList)
                } else {
                    addBotChatFollows(question + " 관련 자주 묻는 질문이 없습니다. 새로운 키워드를 입력하거나 아래의 추천 키워드를 선택해보세요.", tempRecom)
                }
            } else {
            alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("챗봇 목록 호출중 오류 : ", err);
            setChatList((prev) => {
                const updated = prev.filter(chat => chat.source !== 'waiting');
                const newItems = [
                    { 
                        type: 'bot',
                        text: "오류가 발생했어요. 다시 시도해주세요.", 
                        source: 'api', 
                        date: getCurrentDate(), 
                        chatTime: getCurrentTime() 
                    },
                ];
                return [...updated, ...newItems]
            });
        }).finally(() => {
            isSendingRef.current = false;
            setTextQuestion("");
        });
        
    }, []);
    

    const handleClickFollowBtn = (data) => {
        addUserChat(data.nttSj);

        const maxLen = 100;
        const summary = data.nttCn.length > maxLen
            ? data.nttCn.slice(0, maxLen) + '...'
            : data.nttCn;
        addBotChatAnswer(summary, data.nttCn);        
    }

    const getChatbotInitInfo = useCallback(async () => {

        if (isSendingRef.current) return;

        isSendingRef.current = true;

        const url = "/chatbot/rule/retrieveChatbotInfo";

        await axiosApi.post(url, {...chatbotInfoParam})
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setChatbotInfo({...res.data.result.chatbotInfo});
                setCdList([...res.data.result.ctgryList]);

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("챗봇 정보 호출중 오류 : ", err);
            setChatList((prev) => {
                const updated = prev.filter(chat => chat.source !== 'waiting');
                const newItems = [
                    { 
                        type: 'bot',
                        text: "오류가 발생했어요. 다시 시도해주세요.", 
                        source: 'api', 
                        date: getCurrentDate(), 
                        chatTime: getCurrentTime() 
                    },
                ];
                return [...updated, ...newItems]
            });
        }).finally(() => {
            isSendingRef.current = false;
        });
        
    }, []);


    const addUserChat = (text) => {
        const nowDate = getCurrentDateStr();

        setChatList(prev => {
            const lastDateInChat = [...prev].reverse().find(item => item.type === 'date')?.dateStr;
            const newChatList = [...prev];

            // 날짜 변경되었으면 날짜 라인 추가
            if (nowDate !== lastDateInChat) {
                newChatList.push({ type: 'date', dateStr: nowDate, date: getCurrentDate() });
            }

            newChatList.push({ type: 'user', text: text, date: getCurrentDate(), chatTime: getCurrentTime() });
            return newChatList;
        });
    }

    const addBotChatFollows = (text, data) => {
        const nowDate = getCurrentDateStr();

        setChatList(prev => {
            const lastDateInChat = [...prev].reverse().find(item => item.type === 'date')?.dateStr;
            const newChatList = [...prev];

            // 날짜 변경되었으면 날짜 라인 추가
            if (nowDate !== lastDateInChat) {
                newChatList.push({ type: 'date', dateStr: nowDate, date: getCurrentDate() });
            }

            newChatList.push({ type: 'bot', text: text, source: 'followup', date: getCurrentDate(), chatTime: getCurrentTime(), followups: data });
            return newChatList;
        });
    }

    const addBotChatAnswer = (text, answer) => {
        const nowDate = getCurrentDateStr();

        setChatList(prev => {
            const lastDateInChat = [...prev].reverse().find(item => item.type === 'date')?.dateStr;
            const newChatList = [...prev];

            // 날짜 변경되었으면 날짜 라인 추가
            if (nowDate !== lastDateInChat) {
                newChatList.push({ type: 'date', dateStr: nowDate, date: getCurrentDate() });
            }

            newChatList.push({ type: 'bot', text: text, source: 'answer', date: getCurrentDate(), chatTime: getCurrentTime(), answer: answer });
            return newChatList;
        });
    }

    const handleClickAllViewBtn = (nttCn) => {
        setAllText(nttCn);
        setOpen(true);
    }

    const handleClickRefeshBtn = () => {
        setInitChat();
    }

    const onKeyDownHandle = (e) => {
        if (e.keyCode === 13 && !isSendingRef.current) {
            getRuleBaseDataForQuestion(e.target.value);
        }
    }

    //날짜 관련 함수
    const getCurrentDateStr = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); 
        const day = String(now.getDate()).padStart(2, "0"); 
        
        const dayNames = ["일", "월", "화", "수", "목", "금", "토"]; // 요일 배열
        const dayOfWeek = dayNames[now.getDay()]; // getDay()는 0(일요일) ~ 6(토요일)
        
        return `${year}.${month}.${day}(${dayOfWeek})`;
    };
    
    //날짜 관련 함수
    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); 
        const day = String(now.getDate()).padStart(2, "0"); 
        
        
        return `${year}${month}${day}`;
    };
    
    //날짜 관련 함수
    const getCurrentTime = () => {
        const now = new Date();
        return now.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    };


    /////////////////////////카테고리 컴포넌트
    const CategoryComp = ({cdList, chageSelCtgry}) => {
        return (
            <div className={style['inform-box']}>
                <ul>
                {
                    cdList.map((cd, index) => {
                        return(
                        // <li key={index} onClick={() => {handleClickCtgry(cd)}}>#{cd.chtbCmtCn}</li>
                        <li key={index} onClick={() => {chageSelCtgry(cd)}}>#{cd.chtbCmtCn}</li>
                        )
                    })
                }
                </ul>
            </div>
        );
    };

    //채팅 리스트 컴포넌트
    const ChatListComp = ({chatList}) => {
        return (
            chatList.map((chat, index) => {

                if (chat.type === 'date') {
                    return (
                        <div key={index} className={style['hr-line']} data-line-order="first">
                            <span>{chat.dateStr}</span>
                        </div>
                    );
                }

                return (
                    <React.Fragment key={index}>
                    {chat.type === 'user' ? (
                        <div className={style['user-talk-box']}>
                            <span className={style['date-txt']}>{chat.chatTime}</span>
                            <p>{chat.text}</p>
                        </div>
                    ) : (
                        /////////////
                        <div className={style['ai-talk-box']}>
                            <strong className={style['ai-avatar']}>AI 상담사</strong>

                                {chat.source === 'waiting' && (
                                    <div className={style['loading-txt-box']}>
                                        <p className={style['loading-txt']}>답변을 생각하고 있어요 </p>
                                        <CircularProgress size="15px" />
                                    </div>
                                )}

                                <div className={style['ai-box']}>
                                    <div className={style['text-box']}>
                                        <div className={style['p-group']}>
                                            <p>
                                                <span>{chat.text}</span> 
                                            </p> 
                                            {chat.source === 'answer' && chat.answer &&
                                                <button className={style['more-btn']} onClick={() => handleClickAllViewBtn(chat.answer)}>
                                                    <span>전체보기</span>
                                                </button>
                                            }
                                        </div>
                                        <span className={style['date-txt']}>{chat.chatTime}</span> 
                                    </div>

                                    {chat.source === 'init' && (
                                        <CategoryComp cdList={cdList} chageSelCtgry={getRuleBaseData}/>
                                    )}

                                    {chat.source === 'followup' && chat.followups && chat.followups.length > 0 && (
                                        <div className={style['inform-box']} data-type="b">
                                            <ul>
                                                {chat.followups.map((item, idx) => (
                                                <li key={idx}
                                                    onClick={() => {handleClickFollowBtn(item)}}
                                                >#{item.nttSj}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                        </div>
                    )}
                    </React.Fragment>
                );
            })
        )
    }

    /////////////////전체 보기/////////////
    const [open, setOpen] = useState(false);
            
    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    return (
        <>
            <HeadSub title="서비스 이용 안내"/>

                <div id="sub-content">
                <div className="inner-wrap" data-pad-type="b">
                    <ChatListComp chatList={chatList}/>
                    <div ref={chatEndRef} />
                </div>

                {/* 추천 질문 */}
                <div className={style['re-question-box']}>
                    <button className={style['refresh-btn']} onClick={() => handleClickRefeshBtn()}>
                        <span>새 대화</span>
                    </button>
                </div>            

                <div className={style["bottom-fixed-box"]}>
                    <div className={style["in-box"]}>
                        <div className={style["input-box"]}>
                            <input type="text" placeholder="키워드를 입력해주세요."
                                value={textQuestion}
                                onChange={(e) => setTextQuestion(e.target.value)}
                                onKeyDown={onKeyDownHandle}
                                disabled={isSendingRef.current}
                            />

                            
                            <button className={style["push-btn"]}
                                onClick={() => getRuleBaseDataForQuestion(textQuestion)}
                                disabled={!textQuestion.trim() || isSendingRef.current}
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <BottomSheet
                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={open}
                onDismiss={onDismiss}
                snapPoints={({ minHeight }) => [minHeight]}
                blocking={false}
                    >
                    <ChatBotServiceInformBox onClose={onDismiss} text={allText}/>
            </BottomSheet>
        </>
    )
}

export default ServiceChat 